var React = require('react');

function CommentSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M150.21 84.35C195.39 51.79 254.84 32 320 32c141.4 0 256 93.1 256 208 0 49.23-21 94.46-56.23 130.08zM64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8A8 8 0 0 0 72 480c66.3 0 116-31.8 140.6-51.4A305 305 0 0 0 320 448a312.39 312.39 0 0 0 78.4-10L72.87 186.37A171.62 171.62 0 0 0 64 240z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.67 480.52l-19.6 25.31a16.06 16.06 0 0 1-22.5 2.8L6.17 53.79a15.94 15.94 0 0 1-2.8-22.41L23 6.17a16.06 16.06 0 0 1 22.5-2.8l588.3 454.84a15.86 15.86 0 0 1 2.87 22.31z","className":"fa-primary","key":2})]);
}

CommentSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = CommentSlash;

CommentSlash.default = CommentSlash;
